import * as React from 'react';

import { SVGProps } from './type';

const RefreshSVG = (props: SVGProps) => {
  const { size = 24, color = '#095CAA' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M23 6a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 110-2h4V7a1 1 0 011-1z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.498 7c-.871 0-1.737.195-2.55.578a6.788 6.788 0 00-2.197 1.674 1 1 0 11-1.502-1.32 8.787 8.787 0 012.846-2.163A7.964 7.964 0 0114.497 5c1.172 0 2.329.263 3.403.77a8.786 8.786 0 012.846 2.162l3.004 3.407a1 1 0 11-1.5 1.322l-3.005-3.407-.002-.002a6.787 6.787 0 00-2.196-1.674A5.963 5.963 0 0014.497 7zM4 16a1 1 0 011-1h5a1 1 0 110 2H6v4a1 1 0 11-2 0v-5z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.339 15.25a1 1 0 011.411.089l3.007 3.409a6.786 6.786 0 002.196 1.674 5.964 5.964 0 002.55.578c.87 0 1.736-.195 2.549-.578a6.786 6.786 0 002.197-1.674 1 1 0 111.503 1.32 8.787 8.787 0 01-2.847 2.163 7.964 7.964 0 01-3.403.769 7.964 7.964 0 01-3.402-.77 8.785 8.785 0 01-2.846-2.162L4.25 16.66a1 1 0 01.089-1.411z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default RefreshSVG;
